import type { JSX } from "react";

import { Flex, Space } from "@mantine/core";

import type { VoiceTask } from "@/sdk";

import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useAgentSdk } from "@/sdk";

import { isConferenceLimitReached } from "../../utils";
import {
    EndCallButton,
    HoldButton,
    LeaveCallButton,
    MuteButton,
    ToggleCallbackPanelButton,
    ToggleDialpadButton,
    ToggleTransferPanelButton,
} from "../Buttons";
import { useControlsStore } from "../controls.store";

export function AssignedCallControls({ task }: { task: VoiceTask }): JSX.Element {
    const { isConference } = useControlsStore();
    const agentSdk = useAgentSdk();
    const { callbackEnabled: isCallbackEnabled } = usePartnerFeatureConfigured();

    /** Disable the transfer button if the conference limit has been reached. Always show when not in a conference. */
    const transferButtonDisabled = isConference && isConferenceLimitReached(task);

    return (
        <Flex gap={"xs"}>
            <ToggleTransferPanelButton disabled={transferButtonDisabled} />
            <ToggleDialpadButton />
            {isCallbackEnabled ? <ToggleCallbackPanelButton /> : null}
            {isConference ? null : (
                <HoldButton
                    task={task}
                    isOnHold={task.holdState.onHold}
                    onPauseCallButtonClick={() => agentSdk.holdCall(task)}
                    onResumeCallButtonClick={() => agentSdk.resumeCall(task)}
                />
            )}
            <MuteButton task={task} />
            <Space />
            {isConference ? <LeaveCallButton task={task} /> : <EndCallButton task={task} />}
        </Flex>
    );
}
